<template>
  <div class="card special-fund-card">
    <el-row :gutter="screenWidth <= 540?5:20" v-if="position == 'left'">
      <el-col :span="screenWidth <= 540?13:screenWidth <= 800?11:10">
        <div>
          <img :src="item.imgUrl" alt="" class="card-img" @click="toDetails(item.status)">
        </div>
      </el-col>
      <el-col :span="screenWidth <= 540?11:screenWidth <= 800?13:14">
        <div class="card-content">
          <h3 class="text-max-3">{{ item.name }}</h3>
          <div class="text-max-5 special-fund-card-text" :class="{ 'special-fund-card-text-pc' : isMobile == 'pc'}" v-if="screenWidth > 540">{{ item.content }}</div>
          <div style="margin-top: 3rem;" class="look-more" @click="toDetails(item.status)" v-if="isMobile == 'pc'">
            {{$t('View')}} <i class="el-icon-right"></i>
          </div>
          <!-- 移动端 -->
          <div style="margin-top: 3rem;" class="look-more-mobile" @click="toDetails(item.status)" v-if="isMobile == 'mobile'">
            {{$t('View')}} <i class="el-icon-right"></i>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="screenWidth <= 540?5:20" v-if="position == 'right'">
      <el-col :span="screenWidth <= 540?11:screenWidth <= 800?13:14">
        <div class="card-content">
          <h3 class="text-max-3">{{ item.name }}</h3>
          <div class="text-max-5 special-fund-card-text" :class="{ 'special-fund-card-text-pc' : isMobile == 'pc'}" v-if="screenWidth > 540">{{ item.content }}</div>
          <div style="margin-top: 3rem;" class="look-more look-more-right" @click="toDetails(item.status)" v-if="isMobile == 'pc'">
            {{$t('View')}} <i class="el-icon-right"></i>
          </div>
          <!-- 移动端 -->
          <div style="margin-top: 3rem;" class="look-more-mobile" @click="toDetails(item.status)" v-if="isMobile == 'mobile'">
            {{$t('View')}} <i class="el-icon-right"></i>
          </div>
        </div>
      </el-col>
      <el-col :span="screenWidth <= 540?13:screenWidth <= 800?11:10">
        <div>
          <img :src="item.imgUrl" alt="" class="card-img">
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'listCard',
  computed: {
    ...mapState(['screenWidth']),
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    position:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      list: [
        {
          title: '基金会创始支持机构',
          id: '1',
          imgList: [
           
          ]
        },
        {
          title: '理事单位',
          id: '2',
          imgList: [
            
          ]
        }
      ]
    };
  },
  methods: {
    toDetails(status) {
		if(status == 0){
			const routeUrl = this.$router.resolve({
			  path: '/specialFundDetails',
			  query: {
			    id: this.item.id
			  }
			})
			window.open(routeUrl.href, "_blank")
		}

    }
  },
};
</script>

<style lang="less" scoped>
.special-fund-card{
  height: 20rem;
}
.special-fund-card-text{
  -webkit-line-clamp: 5;
}
.special-fund-card-text-pc{
  line-height: 1.8rem;
}
.card {
  width: 100%;
  border-radius: 0.5rem;
  overflow: hidden;
  background: #FAFAFB;
  margin-top: 2rem;
}
.look-more {
  width: 5rem;
  padding: 0.5rem;
  background-color: #b8210f;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  color: #FFFFFF;
  border-radius: 1.5rem;
  float: right;
  position: absolute;
  right: 2rem;
  bottom: 2rem;
  cursor: pointer;
}
.look-more-mobile{
  width: 6.5rem;
  padding: 0.5rem;
  height: 1.5rem;
  line-height: 1.5rem;
  text-align: center;
  color: #000;
  border-radius: 1.5rem;
  float: right;
  position: absolute;
  right: 0;
  bottom: 2rem;
  cursor: pointer;
}
.look-more-right{
  left: 2rem !important;
}
.card-content{
  padding: 2rem;
  position: relative;
  height: 16rem;
}
.card-img{
  width: 100%;
  height: 20rem;
  object-fit: cover;
}
</style>